"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
class ErrorBoundary extends _react.Component {
  componentDidCatch(error, errorInfo) {
    return this.props.onDidCatch(error, errorInfo);
  }
  render() {
    return this.props.children;
  }
}
var _default = exports.default = ErrorBoundary;